import { Plans } from '@legacy/pages/plans';
import { Login } from '@legacy/routes/Login/Login';
import { TopbarProvider } from '@legacy/shared/topbar';

type LegacyPlansProps = {
  tenantCountryCode: string;
  stripeCustomer?: string | null;
  showPlansType?: string | null;
};

export { TopbarProvider };

export const LegacyLogin = () => <Login />;

export const LegacyPlans = ({
  showPlansType,
  stripeCustomer,
  ...props
}: LegacyPlansProps) => (
  <Plans
    showPlansType={showPlansType ?? 'no'}
    stripeCustomer={stripeCustomer ?? undefined}
    {...props}
  />
);
